export default "__VITE_ASSET__ca8kxTHsBppdkximeNw$4g__"